export default {
  title: 'Notes Page',
  header: 'Notes',
  tabs: {
    published: 'Published',
    scheduled: 'Scheduled',
    inbox: 'Inbox',
    sent: 'Sent',
    drafts: 'Drafts',
  }
}
